// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/actionMenu/actionMenuCtrl.js#1 $
'use strict';

/**
* @ngdoc controller
* @name tcApp.controllers:ActionMenuCtrl
* @description
* Action Menu is displayed in right sidenav. It contains menus, component links and additional data for a list row.
*
*/
angular.module('tcApp')
.controller('ActionMenuCtrl', function($scope, $q, $log, $location, $window, $mdSidenav, $mdMedia, $mdUtil, $rootScope,
										$document, $sce, $timeout, GlobalService, LegacyScopeService, SystemRouter, WorkflowService,
										MenuService, tcConstants, PerformanceService, MenuCheckService, ToastService,
										WebsysDateTimeLegacyScope) {
	$scope.data = {};
	$scope.bannerData = {};
	$scope.viewModel = { 
		isActionMenuOpen: false,
		actionMenu: {},
		operations: {
			groupByColumn: {},
			filterDateFrom: {},
			filterDateTo: {},
			sortPrimary: {},
			sortSecondary: {},
		},
		messageOptions: {
			messages: [],
			confirmed: true,
			showButtons: null,
			lastClicked: '',
		},
	};
	$scope.globalStrings = GlobalService.getGlobalStrings();
	$scope.logonData = GlobalService.getLogonData();
	$scope.configuration = GlobalService.configuration;
	$scope.toggleItemsOnResize = null;

	$scope.onClose = function() {
		// get triggering element before resetting data
		var triggeringElement = $scope.data.triggeringElement;
		$scope.data = {};
		resetMessageOptions();
		
		if ($scope.toggleItemsOnResize !== null) {
			angular.element($window).off('resize', $scope.toggleItemsOnResize);
			$scope.toggleItemsOnResize = null;
		}
		// Do this here so separate onClose callback is not required
		GlobalService.onModalToggle(false);
		
		if (angular.isDefined(triggeringElement)) {
			actionMenuFocusHandler(triggeringElement);	
		}
	};

	// Removes previous data when action menu is hidden
	// Prevents action menu links persisting when toggling different rows
	$scope.$watch('viewModel.isActionMenuOpen', function(isActionMenuOpen) {
		if (!isActionMenuOpen) {
			$scope.onClose();
		}
		// Don't call onModalToggle when opening here due to timing issue with Assitive Technology
	});
	
	function filterSubMenus(subMenus, listRow) {
		var subMenuIndex = 0;
		subMenus = subMenus.filter(function(item) {
			var hasAllRequiredColumns = true;
			angular.forEach(item.requiredColumns, function(requiredColumn) {
				// If listRow not defined or required column is not populated in listRow exclude the menu
				if ((angular.isUndefined(listRow)) || 
					(!((listRow[requiredColumn]) && (listRow[requiredColumn].value !== '')))) hasAllRequiredColumns = false;
			});
			if (item.subMenus) item.subMenus = filterSubMenus(item.subMenus, listRow);
			if (item.subMenus && item.subMenus.length == 0) return false;
			if (hasAllRequiredColumns) {
				item.subMenuIndex = subMenuIndex;
				subMenuIndex = subMenuIndex + 1;
			}
			return hasAllRequiredColumns;
		});
		return subMenus;
	}
	
	// Catch Global:updated event broadcasted by GlobalService
	var catchUpdateBanner = function(event, data) {
		if (!data) {
			data = {};
		}
		$scope.bannerData = data;
	};
	$scope.$on('Global:updateBanner', catchUpdateBanner);

	$scope.updateActionMenu = function(newData, viewModel) {
		$scope.data = newData;
		
		// extend current viewModel if one is passed in
		if (angular.isDefined(viewModel)) {
			angular.extend($scope.viewModel, viewModel);
		}
		
		// don't bother to add actionMenus for iconProfile or listOptions (sortMenu)
		if ((!$scope.data.actionMenu) && (!$scope.data.actionMenusOff)) {
			$scope.data.actionMenu = angular.copy($scope.viewModel.actionMenu);
			if ((angular.isDefined($scope.data.actionMenu)) && (angular.isDefined($scope.data.actionMenu.subMenus))) {
				$scope.data.actionMenu.subMenus = filterSubMenus($scope.data.actionMenu.subMenus, $scope.data.listRow);
			}
		}

		if (angular.isArray($scope.data.messages)) {
			updateMessageOptions();
		}
		
		if (angular.isDefined($scope.data.listData)) {
			if (angular.isDefined($scope.data.listData.groupByColumn)) {
				$scope.viewModel.operations.groupByColumn = $scope.data.listData.groupByColumn;
			}
			if (angular.isDefined($scope.data.listData.filterDateFrom)) {
				$scope.viewModel.operations.filterDateFrom = $scope.data.listData.filterDateFrom;
			}
			if (angular.isDefined($scope.data.listData.filterDateTo)) {
				$scope.viewModel.operations.filterDateTo = $scope.data.listData.filterDateTo;
			}
			$scope.viewModel.operations.sortPrimary = {};
			$scope.viewModel.operations.sortSecondary = {};
			if (angular.isDefined($scope.data.listData.sortColumn)) {
				$scope.viewModel.operations.sortPrimary.name = $scope.data.listData.sortColumn;
				$scope.viewModel.operations.sortPrimary.order = $scope.data.listData.sortOrder;
			}
			if (angular.isDefined($scope.data.listData.sortSecondaryColumn)) {
				$scope.viewModel.operations.sortSecondary.name = $scope.data.listData.sortSecondaryColumn;
				$scope.viewModel.operations.sortSecondary.order = $scope.data.listData.sortSecondaryOrder;
			}
			//build the column caption property from translations so it can be sorted using orderBy
			if (angular.isArray($scope.data.listData.sortableColumns)) {
				angular.forEach($scope.data.listData.sortableColumns, function(column) {
					column.caption = $scope.data.translations[column.name];
				});
			}
		}
		$scope.filterItemsForScreenSize();
	};

	// Catch Global:updatedActionMenu event broadcasted by GlobalService
	$scope.$on('System:updateActionMenu', function(event, newData, viewModel) {
		$scope.updateActionMenu(newData, viewModel);
	});
	
	/// set to default state
	var resetMessageOptions = function() {
		$scope.viewModel.messageOptions = {
			messages: [],
			confirmed: true,
			showButtons: null,
			lastClicked: '',
		};
	};
	
	/// set up the valid menu messages from the passed in $scope.data.messages
	///  and determine status
	var updateMessageOptions = function() {
		var validMessageTypes = [tcConstants.COMPONENT_MESSAGE_TYPE.ERROR,
					tcConstants.COMPONENT_MESSAGE_TYPE.INFO,
					tcConstants.COMPONENT_MESSAGE_TYPE.WARNING];
		var hasType = {};
		angular.forEach($scope.data.messages, function(messageItem) {
			if (!validMessageTypes.includes(messageItem.messageType)) return;
			if (messageItem.messageText === '') return;
			$scope.viewModel.messageOptions.messages.push(messageItem);
			hasType[messageItem.messageType] = true;
		});
		if (hasType[tcConstants.COMPONENT_MESSAGE_TYPE.ERROR]) {
			// error messages won't be able to continue - do not allow
			$scope.viewModel.messageOptions.confirmed = false;
		} else {
			$scope.viewModel.messageOptions.showButtons = {
				'XCONFIRM': true,
			};
			if (hasType[tcConstants.COMPONENT_MESSAGE_TYPE.WARNING]) {
				$scope.viewModel.messageOptions.showButtons['XDISMISS'] = true;
				$scope.viewModel.messageOptions.confirmed = false;
			}
		}
	};
	
	/// confirm and toggle on menus or dismiss message 
	$scope.processMessageEvent = function($event,confirmed) {
		var lastClickedIconCode = $scope.viewModel.messageOptions.lastClicked;
		resetMessageOptions();
		$scope.viewModel.messageOptions.confirmed = confirmed;
		if (angular.isFunction($scope.data.messageCallbackFunc)) {
			$scope.data.messageCallbackFunc(confirmed);
		}
		if (!confirmed) {
			$mdSidenav('actionMenu').close();
		} else {
			//upon confirm put focus back to selected item
			if (lastClickedIconCode !== '') {
				focusIconInActionMenu(lastClickedIconCode);
			} else if (angular.isObject($scope.data.currentIcon)) {
				focusIconInActionMenu($scope.data.currentIcon.code);
			} else {
				// timeout required to ensure buttons toggled off, and menus re-enabled
				$timeout(function setFocus() {
					$scope.wrapFocus(true);
				},0);
			}
		}
	};
	
	$scope.$on('System:focusActionMenu', function() {
		$scope.wrapFocus(true);
	});

	var focusIconInActionMenu = function(iconCode) {
		if (angular.isDefined(iconCode)) {
			var actionMenuIconLink = $window.document.getElementById('tc_ActionMenu-link-' + iconCode);
			if (actionMenuIconLink) actionMenuIconLink.focus();
		}
		if (!actionMenuIconLink) $scope.wrapFocus(true);
	};
	$scope.$on('System:focusIconInActionMenu', function(event, iconCode) {
		focusIconInActionMenu(iconCode);
	});

	$scope.$on('Global:userLogon', function(event, sessionData) {
		if (sessionData.menuData) {
			$scope.viewModel.actionMenu = sessionData.menuData.actionMenu;
			if (angular.isDefined(sessionData.menuData.scripts) && (sessionData.menuData.scripts.length)) {
				MenuCheckService.applyScripts($scope, sessionData.menuData.scripts);
			}
		}
		$scope.globalStrings = sessionData.globalStrings;
		$scope.logonData = sessionData.logonData;
		$scope.configuration = sessionData.configuration;
	});
	
	$scope.$on('Global:sessionLocked', function() {
		$mdSidenav('actionMenu').close();
	});

	$scope.triggerEvent = function($event, item) {
		if (item.displayOnly) return;
		if (item.name === 'tkCopyClinicalData') {
			var clinicalData = $scope.data.listRow._actionClinicalData;
			if ((angular.isDefined(clinicalData)) && (clinicalData !== '')) {
				if ($window.cspHttpServerMethod(GlobalService.serverMethods[0], 'websys.SYSTEM',
				'', 'SetCopiedClinicalData', clinicalData) === '1') {
				ToastService.show({
					message: $scope.globalStrings['ClinicalDataCopied']
				});
				} else {
					ToastService.show({
						type: 'error',
						message: $scope.globalStrings['XERROR'],
					});
				}
			}
			$mdSidenav('actionMenu').close();
			return;
		}
		var processEventOptions = {
			componentHtmlName: $scope.data.componentHtmlName,
			eventItem: item,
			listRowIndex: $scope.data.rowIndex
		};
		GlobalService.triggerEvent(processEventOptions, $event);
		$mdSidenav('actionMenu').close();
	};
	
	// Toggles icon group or icon action menu description, with fallback to navigate to link
	$scope.toggleOrTriggerLink = function($event, icon) {
		if ((icon.groupIcons) || (icon.actionMenuDescription)) {
			if ($scope.viewModel.messageOptions.showButtons) {
				$scope.viewModel.messageOptions.lastClicked = icon.code;
			}
			$scope.viewModel.expandedGroups[icon.code] = !$scope.viewModel.expandedGroups[icon.code];
			return;
		}
		$scope.triggerLink($event, icon);
	};

	$scope.triggerLink = function($event, icon) {
		if ($scope.viewModel.messageOptions.showButtons) {
			$scope.viewModel.messageOptions.lastClicked = icon.code;
		}
		if (!$scope.viewModel.messageOptions.confirmed) return;
		if (!icon.linkUrl) return;
		$mdSidenav('actionMenu').close();
		if ((icon.isInfoLink) || (icon.keepOpenUrl)) {
			$window.open(icon.linkUrl, '_blank');		
			return false;
		}
		if (icon.linkUrl.toLowerCase().indexOf(tcConstants['URL_PROTOCOL']['HTTP']) === 0) {
			GlobalService.openWindow(icon.linkUrl, icon.name);
		} else if (icon.linkUrl.toLowerCase().indexOf(tcConstants['URL_PROTOCOL']['SKYPE']) === 0) {
			GlobalService.openWindow(icon.linkUrl, '_blank');
			return false;
		} else {
			$location.url(WorkflowService.getNextLevelUrl(icon.linkUrl));
		}
	};

	$scope.menuClick = function($event, item) {
		var passParameters, newLocation;
		var menuPromiseChain = $q.when({}); // Empty chain

		if (item.displayOnly) return;
		if ($scope.data.listRow) passParameters = $scope.data.listRow._passParameters;
		
		// For JS functions assigned to the menu that do additional validation
		if (item.jsCheckFunction) {
			menuPromiseChain = menuPromiseChain.then(function() {
				var promise = $q(function(resolve, reject) {
					// Continue navigation unless return value is explicitly false
					if (MenuCheckService.checkMenu(item, $scope) === false) {
						reject();
					} else {
						// Some link properties can be modified by the JS function
						var newPassParameters = MenuCheckService.getMenuLinkParams();
						if (newPassParameters !== passParameters) {
							passParameters = newPassParameters;
						} else {
							// Action menus can also have a ValueExpression that allows passing
							// extra parameters in addition to the list row parameters.
							//
							// This is already done in the case where MenuCheckService.checkMenu modifies the passParameters
							if (MenuCheckService.hasValueExpressionParams(item)) {
								passParameters += ('&' + item.valueExpressionParams.substr(1));
								passParameters = GlobalService.maskUrl('?' + passParameters);
								passParameters = passParameters.split('?')[1];
							}
						}
						resolve();
					}
				});
				return promise;
			});
		}
		
		// If we have a link function, add link function call to the promise chain
		if (item.linkFunction) {
			menuPromiseChain = menuPromiseChain.then(function() {
				var promise = $q(function(resolve, reject) {
					/// Prepare legacy scope to watch for window.location changes
					for (var i = 0; i < item.linkFunctionParams.length; i++) {
						if (item.linkFunctionParams[i] === 'event') {
							// Pass the item instead of the event
							// Because we don't want to derive the item from the event.target (HTML element)
							item.linkFunctionParams[i] = item;
						} else if (item.linkFunctionParams[i] === '$event') {
							item.linkFunctionParams[i] = $event;
						}
					}
					LegacyScopeService.clearLocationRedirect();
					GlobalService.callFunction($scope.data.componentHtmlName, item.linkFunction,
														item.linkFunctionParams, function(result) {
						
						// If our js handler explicitly returns false, don't redirect/run cache method
						// If our js handler opened any child windows, don't navigate the main window
						if ((result === false) || (GlobalService.linkedWindowItems.length > 0)) {
							reject();
						} else {
							if (LegacyScopeService.getLocationRedirect() != '') {
								// Override the item's linkURL with the url generated by the click handler
								// (ensures we can run Click Handler -> Cache Method with all request params)
								item.linkUrl = LegacyScopeService.getLocationRedirect();
								// Variable is used when processing results
								newLocation = item.linkUrl;
								// change passed parameters if custom script changed window.location
								passParameters = LegacyScopeService.getLocationRedirect().split('?')[1];
							}
							resolve();
						}
					});
				});
				return promise;
			});
		}
		
		// Call server side method if there is any
		if (item.hasMethod) {
			menuPromiseChain = menuPromiseChain.then(function() {
				if (angular.isUndefined(passParameters) && angular.isDefined(item.linkUrl)) {
					passParameters = item.linkUrl.split('?', 2)[1];
				}
				return SystemRouter.runMenuMethod(item.id, passParameters);
			});
		} 
		
		newLocation = item.linkUrl;

		// Finally, process results
		menuPromiseChain = menuPromiseChain.then(function(result) {
				if (result && result.data) {
					if (result.data.error || result.data.messages) {
						if (result.data.error) {
							$rootScope.$broadcast('Component:updateError', $scope.data.componentHtmlName, result.data.error);
						} else if (result.data.messages) {
							$rootScope.$broadcast('Component:updateMessages', $scope.data.componentHtmlName, result.data.messages);
						}
						$mdSidenav('actionMenu').close();
						return;
					} else {
						if (result.data.location) {
							newLocation = result.data.location;
						} else {
							newLocation = $scope.addPassParameters(newLocation, passParameters);
						}
						angular.forEach(result.data.localPrintingUrls, function callLocalPrinting(localPrintingUrl) {
							GlobalService.callFunction($scope.data.componentHtmlName, 'websys_printlocal',
														[tcConstants.PRINT_MODE.LOCAL, '', '', '', '', '', localPrintingUrl]);
						});
					}
				} else {
					newLocation = $scope.addPassParameters(newLocation, passParameters);
				}
				
				$mdSidenav('actionMenu').close();
				if (angular.isUndefined(newLocation)) return;
				
				PerformanceService.onMenu(item.id);
				
				if (item.externalUrl) {
					GlobalService.openWindow(newLocation, item.name, item.windowSpecs);
					return;
				}
				
				if (item.displayMode === 'dialog') {
					newLocation = WorkflowService.getNextLevelUrl(newLocation);
				}
				
				if (newLocation !== '') {
					$location.url(newLocation);
				}
			}, function() {
				// ensure the action menu is closed regardless of JS handler / cache function etc
				$mdSidenav('actionMenu').close();
				return false;
			});
			
		return menuPromiseChain;
	};
	
	$scope.addPassParameters = function(location, passParameters) {
		if (angular.isDefined(passParameters)) {
			if (location.indexOf('websys.csp') == -1) {
				location = location.split('?')[0] + '?' + passParameters;
			} else {
				location = location + '&' + passParameters;
			}
		}
		return location;
	};
	
	// Returns whether or not to display action menu
	$scope.showActionMenu = function() {
		if ((angular.isUndefined(($scope.data.actionMenu)))
			|| (angular.isUndefined(($scope.data.actionMenu.id)))
			|| (angular.isUndefined($scope.data.actionMenu.subMenus))
			|| (!$scope.data.actionMenu.subMenus.length)) return false;
	
		// Don't display action menu if banner is displayed for Episode
		if ($scope.bannerData.items && $scope.bannerData.items.BANNEREpisodeID && 
				($scope.bannerData.items.BANNEREpisodeID.value != '') &&
				($scope.data.isAction) &&
				($scope.data.componentHtmlName.indexOf('PAAdm_Tree') == -1) &&
				($scope.data.componentHtmlName.indexOf('PAWaitingListInquiry_List') == -1) &&
				($scope.data.componentHtmlName.indexOf('RBAppointment_List') == -1)) {
			return false;
		}
		
		// Conditionally display action menu depending on required columns on active row data
		// (e.g. CheckLinkDetails requires 'EpisodeID')
		if (angular.isDefined($scope.data.actionMenu.requiredColumns)) {
			if (angular.isUndefined($scope.data.listRow)) return false;
			
			var requiredColumn = '';
			for (var i = 0; i < $scope.data.actionMenu.requiredColumns.length; i++) {
				requiredColumn = $scope.data.actionMenu.requiredColumns[i];
				if (angular.isUndefined($scope.data.listRow[requiredColumn])) return false;
				if ($scope.data.listRow[requiredColumn].value === '') return false;
			}
		}
		return true;
	};
	
	$scope.setOperation = function(name, data) {
		if (($scope.viewModel.operations[name].name === data.name)
			&& ($scope.viewModel.operations[name].order === data.order)) {
			// Toggle off if already selected
			$scope.viewModel.operations[name] = {};
			if (name === 'sortPrimary') {
				$scope.viewModel.operations.sortSecondary = {};
			}
		} else {
			$scope.viewModel.operations[name] = data;
		}
		
		if (name === 'sortSecondary') {
			$scope.viewModel.operations.groupByColumn = {};
		}
	};
	
	// Applies the selected operations to the component and closes the action menu
	$scope.applyOperations = function() {
		var componentHtmlName = $scope.data.componentHtmlName;
		// Timeout used to allow enough time to resolve lookup selection/clear
		$timeout(function applyOperationsTimeout() {
			GlobalService.callFunction(componentHtmlName, 'applyListOperations', [$scope.viewModel.operations]);
		}, 200);
		$mdSidenav('actionMenu').close();
	};
	
	// Reset operations back to component defaults and apply them
	$scope.resetOperations = function($event) {
		var groupByColumn = {};
		var sortPrimary = {};
		var sortSecondary = {};
		if (angular.isDefined($scope.data.listData)) {
			if (angular.isDefined($scope.data.listData.defaultGroupByColumn)) {
				groupByColumn = $scope.data.listData.defaultGroupByColumn;
			}
			if (angular.isDefined($scope.data.listData.defaultSortPrimary)) {
				sortPrimary = $scope.data.listData.defaultSortPrimary;
			}
			if (angular.isDefined($scope.data.listData.defaultSortSecondary)) {
				sortSecondary = $scope.data.listData.defaultSortSecondary;
			}
		}
		$scope.viewModel.operations = {
			groupByColumn: groupByColumn,
			filterDateFrom: {},
			filterDateTo: {},
			sortPrimary: sortPrimary,
			sortSecondary: sortSecondary,
		};
		$scope.applyOperations($event);
	};
	
	$scope.onKeypress = function($event, parentMenu, currentMenu, collapsed, rootId) {
		if (($event.keyCode === tcConstants.KEY_CODE.DOWN_ARROW) || ($event.keyCode === tcConstants.KEY_CODE.UP_ARROW)) {
			$event.preventDefault();
			if (angular.isUndefined(parentMenu)) parentMenu = $scope.data.actionMenu;
			MenuService.handleMenuKeydown($event, $scope.data.actionMenu, parentMenu, currentMenu, collapsed, rootId,
									$event.keyCode);
		}
	};
	
	// Focus on opening action menu, or for wrapping focus within the action menu
	// (Roll our own focus logic because md-autofocus does not work correctly...)
	$scope.wrapFocus = function(focusToStart) {
		var focusElement = null;
		var actionMenuElement = $window.document.getElementById('tc_ActionMenu');
		var focusableElementSelector = ('input, button, [tabindex="0"]'
								+ ':not(#tc_ActionMenu-focus-redirect):not(#tc_ActionMenu-focus-bottom)');
		var focusableElements = actionMenuElement.querySelectorAll(focusableElementSelector);
		if (focusableElements.length) {
			if (focusToStart) {
				focusElement = focusableElements[0];
			} else {
				focusElement = focusableElements[focusableElements.length - 1];
			}
		}
		focusElement = (focusElement || $window.document.getElementById('tc_ActionMenu-focus-top'));
		if (focusElement) focusElement.focus();
	};
	
	// Displays html returned for an icon action menu conditional description
	$scope.displayHtml = function(value) {
		return $sce.trustAsHtml(value.toString());
	};
	
	// Given a 'Responsive Display' setting, determines whether menu should be visible for the current screen size
	var isVisibleForScreenSize = function(responsiveDisplay) {
		if (responsiveDisplay.indexOf('gt-') === 0) {
			return $mdMedia(responsiveDisplay);
		} else if (responsiveDisplay.indexOf('hide-') === 0) {
			return !$mdMedia(responsiveDisplay.split('hide-')[1]);
		}
		return true;
	};
	
	// Filter action items based on the responsive display setting & setup resize handler
	$scope.filterItemsForScreenSize = function() {
		if (angular.isDefined($scope.data.listRow)) {
			var responsiveDisplayItems = false;
			['_actionLinks','_actionItems'].forEach(function(actionItemKey) { //eslint-disable-line
				if (angular.isDefined($scope.data.listRow[actionItemKey])) {
					angular.forEach($scope.data.listRow[actionItemKey], function(actionItem) {
						if (actionItem.name === 'tkCopyClinicalData') {
							// Get translated caption from epr.Menu.Messages
							actionItem.actionLinkCaption = $scope.globalStrings['CopyClinicalData'];
						}
						if (angular.isUndefined(actionItem.responsiveDisplayForActionMenu)) {
							// Show by default
							actionItem.showInActionPanel = true;
							return;
						}
						actionItem.showInActionPanel = isVisibleForScreenSize(actionItem.responsiveDisplayForActionMenu);
						responsiveDisplayItems = true;
					});
				}
			});
			
			// When opened from banner, hide action menu items with no data
			if ($scope.data.hideItemsWithNoData) {
				angular.forEach($scope.data.listRow['_actionItems'], function(actionItem) {
					// Match logic in system.UI.Material:TableItemRef
					if ((actionItem.value === '')
						&& ((angular.isUndefined(actionItem.statusClass)) || (actionItem.statusClass === ''))
						&& ((angular.isUndefined(actionItem.statusColour)) || (actionItem.statusColour === ''))
						&& ((angular.isUndefined(actionItem.image)) || (actionItem.image === ''))) {
						actionItem.showInActionPanel = false;
					}
				});
			}
			
			// Setup resize handler if there are any responsive items
			if ((responsiveDisplayItems) && ($scope.toggleItemsOnResize === null)) {
				$scope.toggleItemsOnResize = $mdUtil.debounce($scope.filterItemsForScreenSize, 15);
				angular.element($window).on('resize', $scope.toggleItemsOnResize);
				$scope.$on('$destroy', function() {
					angular.element($window).off('resize', $scope.toggleItemsOnResize);
				});
			}
		}
	};
	
	// Refocus element that opened action menu after closing
	var actionMenuFocusHandler = function(triggeringElement) {
		angular.getTestability(angular.element($document[0].body)).whenStable(function() {
			if (angular.isElement(triggeringElement)) {
				// Only works when original dom element is still on screen
				triggeringElement.focus();
			}
		});
	};
	
	$scope.getGroupByLookupParams = function(item, searchText) {
		if (angular.isUndefined($scope.data.listData)
			|| angular.isUndefined($scope.data.listData.groupByColumns)) {
			return {};
		}
		
		var lookupParams = {
			P1: searchText,
			TBROKERPARAM: 'P1',
			TPARAMCOUNT: ($scope.data.listData.groupByColumns.length + 1)
		};
		angular.forEach($scope.data.listData.groupByColumns, function(groupByColumn, groupByColumnIndex) {
			lookupParams['P' + (groupByColumnIndex + 2)] = (groupByColumn.caption + '^' + groupByColumn.name);
		});
		return lookupParams;
	};

	$scope.setGroupByLookupValue = function(lookupAllValues) {
		var columnName = lookupAllValues.split('^')[1];
		$scope.viewModel.operations.groupByColumn.valueId = columnName;
		if (columnName === $scope.viewModel.operations.sortPrimary.name) {
			$scope.viewModel.operations.sortPrimary = {};
		}
		$scope.viewModel.operations.sortSecondary = {};
	};
	
	$scope.groupByChangeHandler = function(groupByColumn, handleValueChange) {
		if (groupByColumn.value === '') $scope.viewModel.operations.groupByColumn = {};
		return handleValueChange();
	};
	
	$scope.dateChangeHandler = function(sortPanelForm) {
		var filterDateFrom = $scope.viewModel.operations.filterDateFrom;
		var filterDateTo = $scope.viewModel.operations.filterDateTo;
		var dateToBeforeFrom = 0;
		if ((filterDateFrom.value !== '') && (filterDateTo.value !== '')) {
			dateToBeforeFrom = WebsysDateTimeLegacyScope($scope).DateStringCompare(filterDateFrom.value, 
				filterDateTo.value);
		}
		if (dateToBeforeFrom === 1) {
			sortPanelForm.$setValidity('dateRange', false);
		} else {
			sortPanelForm.$setValidity('dateRange', true);
		}
	};

	$scope.$on('Global:callFunction', function(event, componentHtmlName,
		functionName, args, callbackFunction) {
		if (componentHtmlName !== 'ActionMenu') return;

		if (angular.isFunction($scope[functionName])) {
			var returnValue = $scope[functionName].apply(this, args);
			if (angular.isFunction(callbackFunction)) callbackFunction(returnValue);
		} else {
			$log.warn('Could not find function ', functionName, ' in ', componentHtmlName, 'controller');
		}
	});

});
